import type { QuoteViewExpectation } from './types';

export type QuoteDensity = 'flat' | 'accordion';

export const FLAT_DENSITY_MAX_PARENTS = 3;
export const FLAT_DENSITY_MAX_CHILDREN = 15;

export function autoQuoteDensity(expectations: QuoteViewExpectation[]): QuoteDensity {
  let parentCount = 0;
  let childCount = 0;
  for (const expectation of expectations) {
    if (expectation.level === 'PARENT') parentCount += 1;
    else childCount += 1;
  }
  return parentCount <= FLAT_DENSITY_MAX_PARENTS && childCount <= FLAT_DENSITY_MAX_CHILDREN
    ? 'flat'
    : 'accordion';
}
